export const TransactionType = {
  new: 'NEW',
  endorsement: 'ENDORSEMENT',
  cancelled: 'CANCELLED',
  reinstate: 'REINSTATE',
  newbusiness: 'REWRITE / NB',
  cancelledRewrite: 'CANCELLED / REWRITE'
}